import React, { useState,useEffect,lazy,Suspense } from 'react';
import PeriodSlider from '../../components/GlobalComponents/PeriodSlider/PeriodSlider';
import { useSelector } from 'react-redux';
import { useGetPriodById } from '../../components/Login/Hooks/Index';
import CircularProgress from '@mui/material/CircularProgress';
import { useGetDashBoardDataByyTenantId
 } from './Hooks/index';
import {Grid,Box,Typography} from '@mui/material';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import AllTenantDash from './LComponents/AllTenantDash/AllTenantDash';
import { sendPushNotification } from '../Settings/Api';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const Index :React.FC=function(){
  const[priodId,setPriodId]=useState<string|null>(null)
  const [value, setValue] = React.useState(0);
  function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box >
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }
  const onSuccesss=():void=>{

  }
  
  const onFailed=():void=>{
  
  }

  const tenantId:string=useSelector((state:any)=>state.meetings.profileTenantId);
  const[periodId,setPeriodId]=useState<string|null>(null);
  const{data:perData,isLoading:perLoading,isError:periodError,isFetched}:any=useGetPriodById(tenantId,onSuccesss,onFailed);
  useEffect(() => {
    if (perData) {
      let length = perData?.map((e: any) => e.isCurrent).indexOf(true);
    setPeriodId(perData[length].id);
    setActiveIndex(length);
    }
    }, []);

  const{data:dashBoardData,isLoading:getObjectiveLoading1}
    =useGetDashBoardDataByyTenantId(periodId,tenantId);
  // const[periodId,setPeriodId]=useState<string|null>(null);
  // const[setDashBoard,setAllDashBoard]=useState<any[]>();
  // const{data:dashBoardData,isLoading:getObjectiveLoading}
  // =useGetDashBoardDataByyTenantId(periodId,tenantId)
  const[activeIndex,setActiveIndex]=useState<number>(0);
  // const[allObjective,setAllObjective]=useState<any[]>()

  useEffect(() => {
  if(perData){
    const active:any=perData?perData[activeIndex]:{};
  setPeriodId(active.id);
  }
  }, [activeIndex]);


  ////
  const requestNotificationPermission = async () => {
    const permission = await Notification.requestPermission();
    if (permission === 'granted') {
        console.log('Notification permission granted.');

        // ثبت Service Worker
        const registration = await navigator.serviceWorker.ready;
        
        // اشتراک برای دریافت نوتیفیکیشن
        const subscription = await registration.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: 'BH-cnnr2dgM5qkFAikxQAln-hRcCvdaxSy8Zb2HGwkGKDarbIrNIc8IyLfwSXo58jSVbAAoj_av3Z3_sv7Lu5mY'
        });

        console.log('User is subscribed:', subscription);

        // ارسال subscription به سرور
        sendPushNotification(subscription);
    } else {
        console.log('Notification permission denied.');
    }
  };
  requestNotificationPermission();
  ////

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  
  return (
    <>
    <PeriodSlider 
    setActiveIndex={setActiveIndex}
    setPriodId={setPeriodId}
    activeIndex={perData?.findIndex((item:any)=>item.isCurrent)}
    tenantId={tenantId }     
    slideData={perData}
    dataLoading={perLoading}
      />
{/* 
<PeriodSlider 
    setPriodId={setPriodId}
    activeIndex={perData?.findIndex(item=>item.isCurrent)}

    setActiveIndex={setActiveIndex}
    
     slideData={perData || []}
     dataLoading={false}
     

    
    /> */}




      <Grid container   >
      <Grid item xs={12} md={12}  >

<Box sx={{ width: '100%' }}>
  <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
    <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
      <Tab label="داشبورد" {...a11yProps(0)}  style={{color:'black', fontWeight:'700'}}  />
   
    </Tabs>
  </Box>

  
  <CustomTabPanel value={value} index={0}>
    <Suspense fallback={<Box width={'100%'} pt={5} textAlign={'center'} py={5}  ><CircularProgress/></Box>}  >
     <AllTenantDash 
      periodId={periodId}  
      periodsData={perData}
      data={dashBoardData}
      dashBoardData={dashBoardData}
     />
    </Suspense>
  </CustomTabPanel>
</Box>





</Grid>
      </Grid>
    </>
  )
}

export default Index